module.exports = __webpack_public_path__ + "img/portraits_10_V.0dc2bd18.webp";